import { CMS_Content_Module_VideoChapters } from './types';
import { VideoChapters } from '@project/site/modules/video-chapters';

export const VideoChaptersContentModule = (props: CMS_Content_Module_VideoChapters) => {
  return (
    <VideoChapters
      video_url={props.video_url}
      chapters={props.chapters}
      player_type={props.player_type}
    />
  );
};
